import React from 'react';
import Image from 'next/image';
import { ProcessedImage } from 'lib/getImages';

const ImageRow: React.FC<{
  images: ProcessedImage[];
  scaledWidths: number[];
  containerHeight: number;
  gap: number;
  onImageClick?: (index: number) => void;
}> = ({ images, scaledWidths, containerHeight, gap, onImageClick }) => (
  <>
    {/* Blurred background image */}
    {images[0] && (
      <Image
        src={images[0]?.blurDataURL}
        alt="blurred background"
        layout="fill"
        objectFit="cover"
        className="z-0"
        style={{
          filter: 'blur(16px)',
          opacity: 0.5,
          position: 'absolute',
          inset: 0,
        }}
        priority
        unoptimized
      />
    )}
    {/* Images row */}
    <div className="flex h-full relative z-10">
      {images?.map((image, index) => (
        <div
          key={index}
          style={{
            width: scaledWidths[index],
            height: containerHeight,
            cursor: 'pointer',
            boxSizing: 'content-box',
            position: 'relative',
          }}
          className="relative"
          onClick={() => onImageClick?.(index)}
        >
          <Image
            src={image.url}
            alt={image.alt}
            fill
            priority={index < 5}
            className="max-w-none"
            loading="eager"
            unoptimized
            blurDataURL={image.blurDataURL}
            style={{
              objectFit: 'cover',
              background: '#fff',
              paddingRight: index !== images.length - 1 ? gap : 0,
            }}
          />
        </div>
      ))}
    </div>
  </>
);

export default ImageRow;
